<template>
  <div>
        <base-header class="pb-6  bg-gradient-info">

      
      
      
    </base-header>

    <!--Charts-->
     
    <div class="container-fluid mt--6">
     <div class="row justify-content-center">
     
     
      	  <div class="col">
      	    

            <div class="card" style="">
              <!-- Card header -->
              <div class="card-header bg-gradient-default">
              	<h2 class="heading mb-0 text-white">{{model.type_str}}</h2>  	
              

              </div>
              <!-- Card body -->
              <div class="card-body">
              	 <div style="margin-top:10px;">
                		<span class="h6 surtitle">Date Created</span>
              		  <div class="h4">{{model.created_at_str}}</div>
             	 </div>
             	 
             	  <div style="margin-top:30px;">
                		<span class="h6 surtitle">Request Status</span>
              		  <div class="h4">
              		  		<span v-if="model.status==1">In Progress</span>
              		  		<span v-if="model.status==4">Completed</span>
              		  		<span v-if="model.status==5">Cancelled</span>
              		  </div>
             	 </div>
             	 
              	  <div style="margin-top:50px;">
                		<span class="h6 surtitle">Request Description</span>
              		  <div class=""><span style="white-space: pre;">{{model.description}}</span></div>
             	 </div>
             	 
             	 <div style="margin-top:50px;">
                		<span class="h6 surtitle">Information Required From Client</span>
              		  <div class="">
              		  	 <div v-if="model.type==1">
              		  	 	<ul>
              		  	 		<li style="">Particulars of new director including address, nationality, NRIC, email address and contact number.</li>
                				<li style="">Date on which director is appointed.</li>
                			</ul>
              		  	 
              		  	 </div>
              		  
              		  </div>
             	 </div>
             	 
             	 
      			
      			  
              	  <div style="margin-top:50px;">
                		<span class="h6 surtitle"></span>
              		  <div class="">  <base-button v-if="invoice.id" type="primary" @click="goToInvoice">View Invoice</base-button>
              		  				 <base-button v-else type="warning">Invoice Not Yet Created</base-button>
              		  </div>
             	 </div>
      			                 		
    
              </div>
             
            </div>
            <!-- end card-->
     
    

       	 </div>
       	 
       	 
       	 
       	 
      </div>
      <!-- End row-->
      
      <div class="row">
       <div class="col-xl-6"><!-- start left column -->
      		<div style="margin-top:30px;"><h1>Documents</h1></div>
      		
      		<!-- start: documents -->
				<div class="row " style="">
					
					
					<!-- start -->
					  <div v-if="main_document_id" class="col-md-auto" @click="viewDocument(main_document_id)">
					   <card  >
						  <div class="row align-items-center">
							<div class="col-auto">			  
							   <div class="icon icon-shape text-white rounded-circle shadow bg-danger">
									<i class="fa fa-file-alt"></i>
								</div>
							</div>
							<div class="col ml--2">
							  <h4 class="mb-0">
								Main Document For This Request
							  </h4>

							</div>
							<div class="col-auto">
							</div>
						  </div>
						</card>
						</div>
 					<!-- end -->
 					
 					
 					<!-- start -->
					  <div v-for="d in documents" class="col-md-auto" @click="viewReqDoc(d.id)" :key="d.id">
					   <card  >
						  <div class="row align-items-center">
							<div class="col-auto">			  
							   <div class="icon icon-shape text-white rounded-circle shadow bg-success">
									<i class="fa fa-file-alt"></i>
								</div>
							</div>
							<div class="col ml--2">
							  <h4 class="mb-0">
								{{d.document_name}}
							  </h4>

							</div>
							<div class="col-auto">
							</div>
						  </div>
						</card>
						</div>
 					<!-- end -->
 					
 					
 					
 					
 					
				</div><!-- end documents row -->
				
				<!-- start upload doc -->
				<div class="row">
					
 					<div class="col-md-auto">
 						<card>
 							<form style="padding-bottom:20px;">
 								<input type="file" id="file" ref="new_file" class="btn btn-default" />
 							</form>
 							 <base-button block type="primary" @click.prevent="uploadFile">Upload File</base-button>
 						</card>
 					</div>
 					
				</div>
				<!-- end upload doc -->

		</div> <!-- end left column -->
		
		  <div class="col-xl-6"> <!-- start right column -->
		  		
		  		<div style="margin-top:30px;"><h1>Messages</h1></div>
      	
				<!-- start: send message -->
				<div class="row " style="padding-bottom:40px;">
					<div class="col">
					<div class="card">
						<div class="card-body" style="min-height:150px;">
							 <form>
						  <base-input>
							<textarea placeholder="Send a message to your company secretary." class="form-control" v-model="new_message.message" rows="3"></textarea>
						  </base-input>
						</form>
						 <base-button block type="primary" @click.prevent="submitCreateMessage">Send</base-button>
				
				
						</div>
					</div>
					</div><!-- end column -->
			
				 </div>
				 <!-- end: send message -->
		
		
		
				<!-- start: messages -->
				<div class="row ">
					<div class="col-xl-12" v-for="m in messages" :key="m.id">
					<card class="">
						 <!-- Card header -->
						<div slot="header" class="row align-items-center " style="padding:0px;">
						  <div class="col-8">
							<!-- Title -->
							 <base-button v-if="m.is_client==1" icon type="success">
								<span class="btn-inner--icon"><i class="fa fa-user-tie"></i></span>
							  </base-button>
							  
							   <base-button v-if="m.is_client==2" icon type="default">
								<span class="btn-inner--icon"><i class="ni ni-badge"></i></span>
							  </base-button>
							  
							  
							<span class="h5"> 
								<span v-if="m.is_client==1"> Me </span>
								<span v-if="m.is_client==2"> Secretary</span>
							</span>
						  </div>
						  <div class="col-4 text-right">
							<span class="h5">{{m.created_at_str}}</span>
						  </div>
						</div>
						
						<div class="card-text" style="min-height:90px;">
						<span style="white-space: pre;">	{{m.message}} </span>
						</div>
						
					</card>
					</div><!-- end column -->
			
				 </div>
				 <!-- end: messages -->
		  </div><!-- end right column -->
	</div><!-- end 2nd row -->

    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
      	 entity_name:'',
      	 main_document_id:0,
      	 new_message:{
      	 	message:'',
      	 },
      	 invoice:{
      	 	id: 0,
      	 
      	 },
      	 messages:[],
      	 documents:[],
		 model:{
		 	type: '',
		 	description:'',
		 }	
      };
    },
    methods: {
      submitCreateMessage() {
      	if(!this.new_message.message){
      		swal.fire({
							title: `Oops`,
							text: "Please enter a message before sending.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
      	
      	}else{
      		 swal.showLoading();
			 let uri = this.$base_url+'/api/v1/c/create_message';
			 ApiService.post(uri, this.new_message).then(response => {
				this.loadRequestPage();
				 swal.close();
   
			})
      	}

      },
      viewDocument(did){
      			this.$router.push( '/view-document/'+ did +"/0");
        },
      viewReqDoc(did){
      		this.$router.push( '/view-request-document/'+ did);
      
      },
      goToInvoice(){
      		this.$router.push( '/view-invoice/'+	this.invoice.id);
      },
      uploadFile(){
      		if(!this.$refs.new_file.files[0]){
      			swal.fire({
							title: `Oops`,
							text: "Please select a file before uploading.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
      	
     	 	}else{
     	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    
  			     let uri = this.$base_url+'/api/v1/c/upload_req_doc/'+ this.$route.params.rid;
				 ApiService.post(uri,formData).then(response => {
						this.loadRequestPage();
						swal.close();
			
				  })
			}
      
      },
      
      loadRequestPage(){
      	const client_info = JSON.parse(TokenService.getUserInfo());
    	this.entity_name = client_info.entity_name;
    	
    	
		let uri = this.$base_url+'/api/v1/c/get_request/'+ this.$route.params.rid;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.model = response.data.request;
   			 this.new_message.eid = this.model.entity_id;
   			 this.new_message.rid = this.model.id;
   			 this.main_document_id = response.data.main_document;
   			 
   			 this.messages = response.data.messages;
   			 this.documents = response.data.documents;
   			 if(response.data.invoice){
   			 	this.invoice = response.data.invoice;
   			 }
      	})

      
      }
    },
    mounted() {
    
    	this.loadRequestPage();
    
    	
      	
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














